import Swiper from 'swiper/bundle';

window.Swiper = Swiper;

$(document).ready(function() {

    var swiperCase = new Swiper('[data-gallery="case"]', {
        speed: 300,
        grabCursor: true,
        spaceBetween: 32,
        slideClass: 'case-item',
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        breakpoints: {

            0: {
                slidesPerView: 1,
            },

            768: {
                slidesPerView: 2,
            },

            1200: {
                slidesPerView: 3,
            }
        }
    });

    var swiperCase_item = new Swiper('[data-gallery="case_item"]', {
        slidesPerView: 1,
        speed: 300,
        grabCursor: true,
        spaceBetween: 0,
        grabCursor: true,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    $('[data-case_toggler]').mouseover(function() {
        $(this).parents('.case-item').addClass('show')
    });

    $(".case-item").mouseleave(function() {
        if ($(this).hasClass('show')) {
            $(this).removeClass('show')
        }

    });

});